import {ApolloProvider} from "@apollo/client";

import {useUserManager} from "@/context/Login";
import {useMemo} from "react";
import {createClient} from "./factory";
import {store} from "@/store";

const ClientProvider = ({children}: {children: React.ReactNode}) => {
    const userManager = useUserManager();
    const client = useMemo(() => createClient(store, userManager), [userManager]);

    return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default ClientProvider;
